var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.elementId}},[_c('label',{staticClass:"question-label"},[_vm._v(_vm._s(_vm.question))]),_c('vue-dropzone',{ref:"questionDropzone",attrs:{"id":_vm.elementId + '_drop',"options":_vm.dropzoneOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }